import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../models/field';
import { FieldConfig } from '../../models/field-config';

@Component({
  selector: 'app-form-cpr',
  templateUrl: './form-cpr.component.html',
  styleUrls: ['./form-cpr.component.css']
})
export class FormCprComponent implements Field {

  config: FieldConfig;
  group: FormGroup;


}
